import React, { useEffect, Fragment, useCallback, useState } from 'react';
import { useForm } from 'react-hook-form';
import {
    Col,
    Button,
    FormGroup,
    Label,
    Form,
    Modal,
    ModalHeader,
    ModalBody,
    ListGroup,
    ListGroupItem
} from 'reactstrap';
import api from '../../services/api';
import { toast } from 'react-toastify';
import { useAuth } from '../../Context/Auth/AuthContext';

export default function ModalEditCallLogFromEvent(props) {
    const { modalEditLog, toggleModalEditLog, targetEvent, toggleModalTargetEvent } = props;

    const { currentGroup, toggleLoading } = useAuth();
    const { register, handleSubmit } = useForm({});
    const [logs, setLogs] = useState([]);
    const [currentLog, setCurrentLog] = useState();
    const [editNote, setEditNote] = useState('');

    useEffect(() => {
        if (modalEditLog === true) {
            setLogs([]);
            setCurrentLog();
            setEditNote('');
            api.post(`/ro.team.listLogGiftByGiftId/${currentGroup.id}`, {
                giftId: targetEvent.id
            })
                .then((response) => {
                    setLogs(response.data);
                    if (response.data.length === 1) {
                        setCurrentLog(response.data[0]);
                        setEditNote(response.data[0].notes);
                    }
                })
                .catch((err) => {
                    toast.error(err.response.data.message);
                });
        }
    }, [modalEditLog, currentGroup, targetEvent, setLogs, setCurrentLog, setEditNote]);

    const onSubmitEditLogCall = useCallback(async () => {
        toggleLoading(true);
        api.patch(`/ro.team.modifyLogGift/${currentGroup.id}`, {
            notes: editNote,
            logId: currentLog.id,
            receiverId: currentLog.receiverId
        })
            .then(() => {
                toast.success('Gift Log edited!');
                toggleModalEditLog();
                toggleModalTargetEvent();
                document.body.classList.remove('modal-open');
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            })
            .finally(() => {
                toggleLoading(false);
            });
    }, [toggleLoading, currentGroup, currentLog, editNote, toggleModalEditLog, toggleModalTargetEvent]);

    const convertDate = useCallback((date) => {
        const month = parseInt(date.substring(4,6)) - 1;
        const dateObj = new Date(
            date.substring(0,4),
            month,
            date.substring(6,8),
            date.substring(8,10),
            date.substring(10,12),
            0
        );
        const hour = dateObj.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
        return `${date.substring(0,4)}/${date.substring(4,6)}/${date.substring(6,8)} ${hour}`;
    }, []);

    return (
        <Fragment>
            <Modal isOpen={modalEditLog} toggle={toggleModalEditLog}>
                <ModalHeader toggle={toggleModalEditLog}>
                    Edit Call Log
                </ModalHeader>
                <ModalBody>
                    {logs.length > 0 && !currentLog && (
                        <Fragment>
                            <ListGroup className="todo-list-wrapper" flush>
                                {logs && logs.map((log) => (
                                        <ListGroupItem key={log.id}>
                                            <div className="widget-content p-0">
                                                <div className="widget-content-wrapper">
                                                    <div className="widget-content-left">
                                                        <div className="widget-heading">
                                                            {convertDate(log.date)}
                                                        </div>
                                                        <div className="widget-subheading">
                                                            Notes: {log.notes}
                                                        </div>
                                                                                                               
                                                    </div>
                                                    <div className="widget-content-right">
                                                        <Button
                                                            color="primary"
                                                            onClick={() => {
                                                                setEditNote(log.notes);
                                                                setCurrentLog(log);
                                                            }}
                                                        >
                                                            Edit
                                                        </Button>
                                                    </div>
                                                </div>
                                            </div>
                                        </ListGroupItem>
                                    ))}
                            </ListGroup>
                        </Fragment>
                    )}
                    {currentLog && (
                        <Fragment>
                            <Form>
                                <FormGroup row>
                                    <Label sm={2}>
                                        Date
                                    </Label>
                                    <Col sm={10}>
                                        <input
                                            type="text"
                                            disabled={true}
                                            value={convertDate(currentLog.date)}
                                            className="form-control"
                                        />
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Label for="notes" sm={2}>
                                        Notes
                                    </Label>
                                    <Col sm={10}>
                                        <input
                                            id="notes"
                                            name="notes"
                                            ref={register}
                                            className="form-control"
                                            value={editNote}
                                            onChange={(e) => {
                                                setEditNote(e.target.value);
                                            }}
                                        />
                                    </Col>
                                </FormGroup>

                                <div className="text-center">
                                    <Button
                                        className="btn-wide mb-2 mr-2"
                                        size="md"
                                        color="success"
                                        onClick={handleSubmit(onSubmitEditLogCall)}
                                    >
                                        Done
                                    </Button>

                                    <Button
                                        className="btn-wide mb-2 mr-2"
                                        size="md"
                                        color="danger"
                                        onClick={() => {
                                            toggleModalEditLog();
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </div>
                            </Form>
                        </Fragment>
                    )}
                    
                </ModalBody>
            </Modal>
        </Fragment>
    );
}
